import { Alert, Box, Button, Chip, Container, Menu, MenuItem, Popover } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import momen from "moment";
import axios from 'axios';
import { LocalShipping } from '@mui/icons-material';

class NotifyFuDataPendingTele extends Component {
    state = { 
        anchorEl: null,
        isMenuOpen: false,
        appNumber: Global.getAppProfile().waNumber
     } 

    handleClick = (event) => {
        console.log(event);
        this.setState({anchorEl: event.target, isMenuOpen: true});
    };
    handleClose = (messageText) => {
        this.setState({anchorEl: null, isMenuOpen: false});
        // this.props.onOpenCreateOrder(messageText);
    };

    getContactInfo = (waNumber) => {
        console.log("INIPROPS", this.props)
        let params = {
            waNumber: waNumber
        } 
        axios
        .post(Api.getContactInfo(), params, Api.getRequestHeader())
        .then((response) => {
            let responseData = response.data;
            if(responseData.success === true){
                let contact = this.props.generateItemConversation(responseData.data);
                this.props.handleConversationSelected(contact);
            }
        })
        .catch((error) => {
            this.setState({ errorMessage: error.message });
            console.error("There was an error!", error);
        });
    }

    render() { 
        return (
            <Box sx={{m: "5px"}}>
                <Alert variant="filled" severity="warning" action={
                    <Button variant='contained' size="small" onClick={this.handleClick}>
                        Fu Sekarang!!!
                    </Button>
                }>
                    Ada {this.props.listFuDataPendingTele.length} customer tele yang perlu di Follow Up!!!
                </Alert>
                <Menu
                    id={"menu-pesan-belum-dibalas"}
                    anchorEl={this.state.anchorEl}
                    open={this.state.isMenuOpen}
                    onClose={this.handleClose}
                    MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    }}
                >
                    {
                        this.props.listFuDataPendingTele?.map(item => {
                            return <MenuItem disabled={this.state.appNumber !== item.to} onClick={() => this.getContactInfo(item.from)}>
                                <Container className='border rounded border-warning' style={{backgroundColor: "#fef8e5"}}>
                                    <small><strong>{item.fromName}</strong></small>
                                    <div style={{display: "flex"}}>
                                        <small style={{flex: 1}}>{Global.maskPhoneNumber(item.from)}</small>
                                        <div style={{width: "20px"}}></div>
                                        <div className='text-right'>
                                            <small style={{flex: 1}}><strong>{item.aplikasi} {item.isCsCustomer ? "(CS)" : ""}</strong></small>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        {/* <small><strong>Last Message : </strong></small> */}
                                        <div className="col-6">
                                            <span className={Global.getLabelClasses(item.label)}>{item.label}</span>
                                        </div>
                                        <div className="col-6 text-center">
                                            {
                                                item.hMinValue === "H-1" && <Chip sx={{cursor: "pointer"}} label={<Box sx={{fontSize: "10px"}}><LocalShipping sx={{width: "12px"}} /> H-1</Box>} color='warning' size='small' />
                                            }
                                            {
                                                item.hMinValue === "H-3" && <Chip sx={{cursor: "pointer"}} label={<Box sx={{fontSize: "9px"}}><LocalShipping sx={{width: "12px"}} /> H-3</Box>} color='secondary' size='small' />
                                            }
                                            {
                                                item.hMinValue === "H-7" && <Chip sx={{cursor: "pointer"}} label={<Box sx={{fontSize: "9px"}}><LocalShipping sx={{width: "12px"}} /> H-7</Box>} color='primary' size='small' />
                                            }
                                            {
                                                item.hMinValue === "H-0" && <Chip sx={{cursor: "pointer"}} label={<Box sx={{fontSize: "9px"}}><LocalShipping sx={{width: "12px"}} /> Expired</Box>} color='error' size='small' />
                                            }
                                            <Box sx={{fontSize: "10px", textAlign: "center"}}>{Global.formatDateTimeToStrDateTime24(item.deliveryDate, true)}</Box>
                                        </div>
                                        
                                        
                                    </div>
                                </Container>
                            </MenuItem>
                        })
                    }
                </Menu>
                {/* <Popover 
                    anchorReference="anchorPosition"
                    anchorPosition={{ top: 50, left: 400 }}
                    open={true}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    >
                    The content of the Popover.
                </Popover> */}
            </Box>
            
        );
    }
}
 
export default NotifyFuDataPendingTele;